import { __ } from '@wordpress/i18n';
import { InspectorControls, BlockControls, AlignmentToolbar, MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';
import { PanelBody, PanelRow, ToggleControl, SelectControl, __experimentalUnitControl as UnitControl, ToolbarGroup, ToolbarButton, Notice } from '@wordpress/components';

// Settings Components
import { Label, HelpPanel, InlineDetailMediaUpload } from '../../Components';
import { pxUnit, perUnit, emUnit } from '../../Components/utils/options';

// import useWPAjaxQuery from './hooks/useWPAjaxQuery';
import { loadingTypes } from './utils/options';

const Settings = ({ attributes, setAttributes }) => {
	const { alignment, model, width, height, isTouchMove, isZoom, loadingType } = attributes;

	// const { data: proInfo, isLoading } = useWPAjaxQuery(bp3dBlock?.ajaxURL, { action: 'bp3d_pipe_checker', _wpnonce: bp3dBlock?.nonce });

	const onModelSelect = ({ id, url, title }) => setAttributes({ model: { ...model, id, url, title } });

	return <>
		<InspectorControls>
			<div className='tdvbInspectorInfo'>
				Need more block like this? Checkout the bundle ➡ <a href='https://wordpress.org/plugins/b-blocks' target='_blank' rel='noopener noreferrer'>B Blocks</a>
			</div>

			<HelpPanel slug='3d-viewer-block' docsLink='https://bblockswp.com/docs/3d-viewer-block' />


			<PanelBody className='bPlPanelBody' title={__('3D Model Settings', 'model-viewer')}>
				<Label className=''>{__('Model Source (.glb or .gltf)', 'b-blocks')}</Label>
				<InlineDetailMediaUpload types={['model/gltf-binary']} value={model} onChange={val => setAttributes({ model: val })} placeholder={__('Enter Model URL', 'b-blocks')} />

				<Notice className='mt10' status='warning' isDismissible={false}>{__('File upload issue? Please refresh this page once, if you just install the plugin from Gutenberg editor.')}</Notice>

				<UnitControl className='mt20' label={__('Width:', 'model-viewer')} labelPosition='left' value={width} onChange={val => setAttributes({ width: val })} units={[pxUnit(), perUnit(), emUnit()]} />
				<small>{__('Keep width 0, to auto width.', 'model-viewer')}</small>

				<UnitControl className='mt20' label={__('Height:', 'model-viewer')} labelPosition='left' value={height} onChange={val => setAttributes({ height: val })} units={[pxUnit(), perUnit(), emUnit()]} />
				<small>{__('Keep height 0, to 350px height.', 'model-viewer')}</small>

				<ToggleControl className='mt20' label={__('Controls via mouse/touch', 'model-viewer')} checked={isTouchMove} onChange={val => setAttributes({ isTouchMove: val })} />

				{isTouchMove && <>
					<ToggleControl className='mt20' label={__('Zoom', 'model-viewer')} checked={isZoom} onChange={val => setAttributes({ isZoom: val })} />
					<small>{__(`Enable 'Controls via mouse/touch' to work Zoom!`, 'model-viewer')}</small>
				</>}

				<PanelRow className='mt20'>
					<Label className=''>{__('Loading Type:', 'model-viewer')}</Label>
					<SelectControl value={loadingType} onChange={val => setAttributes({ loadingType: val })} options={loadingTypes} />
				</PanelRow>
			</PanelBody>
		</InspectorControls>


		<BlockControls>
			{model?.url && <ToolbarGroup className='bPlToolbar'>
				<MediaUploadCheck>
					<MediaUpload allowedTypes={['model/gltf-binary']} value={model?.id} onSelect={onModelSelect} render={({ open }) => <ToolbarButton label={__('Edit 3D Model:', 'model-viewer')} icon='edit' onClick={open} />} />
				</MediaUploadCheck>
			</ToolbarGroup>}

			<AlignmentToolbar value={alignment} onChange={val => setAttributes({ alignment: val })} describedBy={__('3D Model Alignment')} alignmentControls={[
				{ title: __('3D Model in left', 'model-viewer'), align: 'left', icon: 'align-left' },
				{ title: __('3D Model in center', 'model-viewer'), align: 'center', icon: 'align-center' },
				{ title: __('3D Model in right', 'model-viewer'), align: 'right', icon: 'align-right' }
			]} />
		</BlockControls>
	</>;
};
export default Settings;